export default __webpack_public_path__ + "static/media/avatar-03.499f4971.svg";